







































































































































































































































































































































































import { localISODate } from "@/utils/localDate";
import { Component, Vue, Prop } from "vue-property-decorator";
import KepatuhanJatuhStore from "@/store/modules/KepatuhanJatuhStore";
import KepatuhanJatuhService from "@/services/KepatuhanJatuhService";
import http from "@/axios/http-common";

@Component
export default class ObservasiPasienStep extends Vue {
  @Prop({ default: null }) session!: any;
  dialog = false;
  valid = false;
  saving = false;
  error = "";
  cur: any = this.emptyForm();
  instrumentOpts: any[] = [];
  pasienItems: any[] = [];
  pasienSearch: string | null = null;
  pasienLoading = false;
  selectedPasien: any = null;

  required = (v: any) => (v !== null && v !== undefined && v !== "") || "Wajib";
  kategoriOpts = [
    { text: "Dewasa", value: "dewasa" },
    { text: "Anak", value: "anak" },
    { text: "Lansia", value: "lansia" },
    { text: "Obstetri", value: "obstetri" },
    { text: "Psikiatri", value: "psikiatri" }
  ];
  dilakukanOpts = [
    { text: "Dilakukan", value: "dilakukan" },
    { text: "Tidak", value: "tidak" }
  ];

  get store() {
    return KepatuhanJatuhStore;
  }

  get canAdd() {
    return !!(this.session && this.session.id);
  }

  get observations() {
    return (this.session && this.session.observations) || [];
  }

  emptyForm() {
    return {
      no_rm: "",
      nama_pasien: "",
      nik_pasien: "",
      tanggal_asesmen: localISODate(),
      kategori_pasien: "dewasa",
      instrument_id: null,
      skor_risiko: null,
      risiko_jatuh: "tidak_tinggi",
      assessment_awal: "dilakukan",
      assessment_ulang: "dilakukan",
      monitoring_intervensi: "dilakukan",
      edukasi_pasien_keluarga: "dilakukan",
      intervensi_gelang_kuning: false,
      intervensi_penguncian_roda: false,
      intervensi_side_rail: false,
      intervensi_tinggi_bed: false,
      intervensi_pencahayaan: false,
      intervensi_bel_pasien: false,
      ada_kejadian_jatuh: false,
      catatan: ""
    };
  }

  async mounted() {
    await this.loadInstruments();
  }

  async loadInstruments() {
    try {
      const list = await this.store.fetchInstruments({});
      this.instrumentOpts = list || [];
    } catch (e) {
      // fallback — leave empty
      this.instrumentOpts = [];
    }
  }

  resolveInst() {
    const map: Record<string, string> = {
      dewasa: "MFS",
      anak: "HUMPTY_DUMPTY",
      lansia: "MFS",
      obstetri: "MFS",
      psikiatri: "MFS"
    };
    const kode = map[this.cur.kategori_pasien];
    const inst = this.instrumentOpts.find(
      (x: any) => x.kode_instrumen === kode
    );
    if (inst) this.cur.instrument_id = inst.id;
  }

  async classify() {
    if (!this.cur.skor_risiko || !this.cur.instrument_id) return;
    if (!this.session || !this.session.id) return;
    try {
      const res = await KepatuhanJatuhService.classifyRisk(
        this.session.id,
        this.cur.skor_risiko,
        this.cur.instrument_id
      );
      const data = (res && res.data && (res.data.data || res.data)) || {};
      if (data.risiko_jatuh) this.cur.risiko_jatuh = data.risiko_jatuh;
    } catch (e) {
      // silent — keep current
    }
  }

  pasienFilter(item: any, queryText: string) {
    const q = (queryText || "").toLowerCase();
    return (
      String(item.rm || "").toLowerCase().indexOf(q) > -1 ||
      String(item.nama || "").toLowerCase().indexOf(q) > -1
    );
  }

  async doPasienSearch() {
    if (!this.pasienSearch) {
      this.pasienItems = [];
      return;
    }
    this.pasienLoading = true;
    try {
      const res = await http.getDataParam("/pasien", {
        params: { term: this.pasienSearch }
      });
      this.pasienItems = (res.data || []).map((p: any) => ({
        ...p,
        text: `${p.rm} — ${p.nama}`
      }));
    } catch (e) {
      this.pasienItems = [];
    } finally {
      this.pasienLoading = false;
    }
  }

  onPasienSelect(v: any) {
    if (v && typeof v === "object") {
      this.cur.no_rm = String(v.rm || "");
      this.cur.nama_pasien = v.nama || "";
      const nik = String(v.no_identitas || "").trim();
      this.cur.nik_pasien = /^\d{6,20}$/.test(nik) ? nik : "";
    } else {
      this.cur.no_rm = "";
      this.cur.nama_pasien = "";
      this.cur.nik_pasien = "";
    }
  }

  resetPasienPicker() {
    this.selectedPasien = null;
    this.pasienSearch = null;
    this.pasienItems = [];
    this.pasienLoading = false;
  }

  async openDialog() {
    this.cur = this.emptyForm();
    this.resetPasienPicker();
    this.error = "";
    this.dialog = true;
    if (!this.instrumentOpts.length) await this.loadInstruments();
    this.resolveInst();
  }

  edit(obs: any) {
    this.cur = { ...obs };
    this.resetPasienPicker();
    this.error = "";
    this.dialog = true;
  }

  async remove(obs: any) {
    if (!obs.id) return;
    if (!confirm("Hapus observasi ini?")) return;
    try {
      await this.store.deleteObservation({
        id: this.session.id,
        obsId: obs.id
      });
    } catch (e) {
      alert(e.response?.data?.message || "Gagal hapus observasi");
    }
  }

  async save() {
    this.error = "";
    this.saving = true;
    try {
      if (this.cur.id) {
        await this.store.updateObservation({
          id: this.session.id,
          obsId: this.cur.id,
          data: this.cur
        });
      } else {
        await this.store.addObservation({
          id: this.session.id,
          data: this.cur
        });
      }
      this.dialog = false;
    } catch (e) {
      this.error =
        e.response?.data?.message || e.message || "Gagal simpan observasi";
    } finally {
      this.saving = false;
    }
  }

  badge(v: string | null | undefined) {
    if (v === "dilakukan") return "\u2713";
    if (v === "tidak") return "\u2717";
    return "-";
  }
}
